import Links from '../data/Links';

const AdminLinks = (role) => [
	{
		icon: () => null,
		name: 'Dashboard',
		path: Links.DASHBOARD,
		role: ['superAdmin', 'admin'],
	},
	{
		icon: () => null,
		name: 'Analytics',
		path: Links.ANALYTICS,
		role: ['superAdmin', 'admin'],
	},
	{
		icon: () => null,
		name: 'Vehicle Ad',
		path: Links.VEHICLE_AD,
		role: ['superAdmin', 'admin'],
	},
	{
		icon: () => null,
		name: 'Lead Tracking',
		path: Links.LEADS,
		role: ['superAdmin', 'admin'],
	},
	{
		icon: () => null,
		name: 'Upcoming Cars',
		path: Links.UPCOMING_CARS,
		role: ['superAdmin', 'admin'],
	},
	{
		icon: () => null,
		name: 'Vehicle Data',
		path: Links.VEHICLE,
		role: ['superAdmin', 'admin'],
	},
	{
		icon: () => null,
		name: 'Meta Data',
		path: Links.META_DATA,
		role: ['superAdmin'],
	},
	{
		icon: () => null,
		name: 'Vehicle Utils',
		path: Links.UTIL,
		role: ['superAdmin', 'admin'],
	},
	{
		icon: () => null,
		name: 'User',
		path: Links.USER,
		role: ['superAdmin'],
	},
	{
		icon: () => null,
		name: 'Banks',
		path: Links.BANK_FORMS,
		role: ['superAdmin'],
	},
	{
		icon: () => null,
		name: 'Slider image',
		path: Links.SLIDER_IMAGE,
		role: ['superAdmin'],
	},
	{
		icon: () => null,
		name: 'Banner',
		path: Links.BANNER,
		role: ['superAdmin'],
	},
	{
		icon: () => null,
		name: 'Suggestion',
		path: Links.SUGGESTION,
		role: ['superAdmin'],
	},
	{
		icon: () => null,
		name: 'Packages',
		path: Links.PACKAGES,
		role: ['superAdmin'],
	},
	{
		icon: () => null,
		name: 'Services',
		path: Links.SERVICES,
		role: ['superAdmin'],
	},
	{
		icon: () => null,
		name: 'Orders',
		path: Links.ORDERS,
		role: ['superAdmin'],
	},
	{
		icon: () => null,
		name: 'Inspection Orders',
		path: Links.INSPECTION_ORDERS,
		role: ['superAdmin'],
	},
	{
		icon: () => null,
		name: 'Booking Calender',
		path: Links.CALENDER,
		role: ['superAdmin'],
	},
	{
		icon: () => null,
		name: 'Tags',
		path: Links.TAGS,
		role: ['superAdmin', 'admin'],
	},
	{
		icon: () => null,
		name: 'User Levels',
		path: Links.USERLEVELS,
		role: ['superAdmin', 'admin'],
	},
];

export default AdminLinks;
